import { Link } from "react-router-dom";
import Input from "../../../Components/Input";
import SearchIcon from "../../../Assets/Icons/outline/search-normal.svg";

const Tab = ({ setPagination, setSearch, tab }) => {
	return (
		<div className="flex items-center justify-between mb-5">
			<div className="font-medium text-center text-black border-b border-gray-200">
				<ul className="flex flex-wrap -mb-px">
					<li className="me-2">
						<Link
							to="/master/member"
							className={`inline-block p-4 rounded-t-lg ${
								tab === "member"
									? "font-semibold border-b border-black active"
									: "border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300"
							}`}
						>
							Member
						</Link>
					</li>
					<li className="me-2">
						<Link
							to="/master/group"
							className={`inline-block p-4 rounded-t-lg ${
								tab === "group"
									? "font-semibold border-b border-black active"
									: "border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300"
							}`}
						>
							Group
						</Link>
					</li>
					<li className="me-2">
						<Link
							to="/master/incentive"
							className={`inline-block p-4 rounded-t-lg ${
								tab === "incentive"
									? "font-semibold border-b border-black active"
									: "border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300"
							}`}
						>
							Incentive
						</Link>
					</li>
				</ul>
			</div>
			<div className="w-1/3">
				<Input
					icon={SearchIcon}
					placeholder="Search..."
					required
					type="text"
					onChange={(evt) => {
						setPagination(1);
						setSearch(evt?.target?.value);
					}}
				/>
			</div>
		</div>
	);
};

export default Tab;
